import axios from "axios";
import { Stats } from "../types/stats";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";
const API = `${API_BASE}/api/stats`;

export async function getLatestStats() {
  try {
    const res = await axios.get(`${API}/latest`);
    return res.data; // { success, data }
  } catch (err) {
    console.error("getLatestStats error:", err);
    return { success: false, data: null };
  }
}

export async function getStatsByDate(date: string) {
  try {
    const res = await axios.get(`${API}/by-date`, { params: { date } });
    return res.data;
  } catch (err) {
    console.error("getStatsByDate error:", err);
    return { success: false, data: null };
  }
}

export async function getAllStats() {
  try {
    const res = await axios.get(`${API}/history`);
    return res.data;
  } catch (err) {
    console.error("getAllStats error:", err);
    return { success: false, data: [] };
  }
}

export async function createStats(payload: Stats, token?: string) {
  try {
    const headers: any = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await axios.post(API, payload, { headers });
    return res.data;
  } catch (err) {
    console.error("createStats error:", err);
    return { success: false, message: "Failed to create stats" };
  }
}
